let ArticleSlider = {};

ArticleSlider.slider = function () {
  let $articleSlider = $('#article-slider');

  $articleSlider.on('ready.flickity', function () {
    $articleSlider.css('visibility', 'visible');
  });

  var options = {
    contain: true,
    cellAlign: 'left',
    groupCells: false,
    prevNextButtons: true,
    pageDots: true,
    dragThreshold: 10,
  };

  $articleSlider.flickity(options);

  let $prevButton = $('.js-flickity-prev');
  let $nextButton = $('.js-flickity-next');

  $prevButton.click(function () {
    $articleSlider.flickity('previous');
  });

  $nextButton.click(function () {
    $articleSlider.flickity('next');
  });
};

ArticleSlider.slider();

$(window).resize(function () {
  ArticleSlider.slider();
});

window.addEventListener('resize', window.stokpress.debounce(function () {
  ArticleSlider.slider();
}, 500));



// WEBPACK FOOTER //
// ./scripts/components/sliders/article-slider.js